import { atom } from "recoil";

export const exchangeCurrencyStore = atom<
  any
>({
  key: "exchangeCurrencyState",
  default: {}
});
